import { Component, Inject, Input } from '@angular/core';
import { DefaultTableSelectionHandler, TABLE_SELECTOR_HANDLER } from '@cbre/components';
import { PropertySet } from '@miq/domain/property-sets';
import { COLUMNS } from './property-set-table.config';
import { STATE_PROVIDER, StateProvider } from '../../services/state-provider/state-provider';
import { PropertySetsState, PropertySetView } from '../../property-sets-dialog/property-sets-dialog';

@Component({
  selector: 'miq-property-set-table',
  template: `
    <!-- PROPERTY SETS TABLE -->
    <div class="fx--padding-20 ps-table">
      <ng-template #resultsCount>
        <cbre-table-title title="Property Set List" [count]="propertySets?.length"></cbre-table-title>
      </ng-template>

      <ng-template #cellRendererTpl let-row="row" let-column="column">
        <span [matTooltip]="row | rowColumnTooltip: column" matTooltipPosition="right"
          >{{ row | dataColumnFormatter: column }}
        </span>
      </ng-template>

      <!-- TABLE -->
      <cbre-table
        [elements]="propertySets"
        [toolboxLeftTpl]="resultsCount"
        [cellRendererTpl]="cellRendererTpl"
        [columns]="columns"
        [pageSize]="10"
        [pageSizeOptions]="[10, 20, 50, 100]"
        maxHeight="600px"
        [stickyHeader]="true"
        [isRowClickable]="true"
        (rowClick)="openPropertySet($event)"
      ></cbre-table>
    </div>
  `,
  styleUrls: ['./property-set-table.component.scss'],
  providers: [{ provide: TABLE_SELECTOR_HANDLER, useClass: DefaultTableSelectionHandler }],
  standalone: false,
})
export class PropertySetTableComponent {
  /**
   * Property Sets to display in the table
   */
  columns = COLUMNS.map(c => ({ ...c }));

  /**
   * Property Sets to display in the table
   */
  @Input() propertySets: PropertySet[] = [];

  constructor(@Inject(STATE_PROVIDER) private propertySetsStateService: StateProvider<PropertySetsState>) {}

  openPropertySet(row: PropertySet) {
    this.propertySetsStateService.patchState({
      id: row.id,
      view: PropertySetView.Details,
      hasBackButton: true,
    });
  }
}
